import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    connect() {

        let toggleOff = this.element.getAttribute('data-toggle-off');
        let toggleOn = this.element.getAttribute('data-toggle-on');

        ['click', 'change', 'input'].forEach(e => {
            this.element.addEventListener(e, () => {
                this.element.classList.toggle('active');

                if (this.element.hasAttribute('data-alt-text')) {
                    const text =  this.element.innerHTML;
                    this.element.innerHTML = this.element.getAttribute('data-alt-text');
                    this.element.setAttribute('data-alt-text', text);
                }

                if (this.element.hasAttribute('data-toggle-group')) {
                    const group = this.element.hasAttribute('data-toggle-group');
                    document.querySelectorAll(`[data-toggle-group=${group}]`).forEach((elm) => {
                        if (this.element !== elm) {
                            elm.classList.remove('active');
                        }
                    });
                }

                if (toggleOff) {
                    toggleOff = toggleOff.split(' ');
                    toggleOff.forEach((clas) => {
                        document.querySelectorAll(`.${clas}`).forEach((elm) => {
                            elm.classList.add('!hidden');
                        });
                    });
                }

                if (toggleOn) {
                    toggleOn = toggleOn.split(' ');
                    toggleOn.forEach((clas) => {
                        document.querySelectorAll(`.${clas}`).forEach((elm) => {
                            elm.classList.remove('!hidden');
                            elm.classList.remove('hidden');
                        });
                    });
                }
            });
        });
    }
}